import * as React from 'react'
import './styles.css'
// components
import Header from './components/Header'
import Map from './components/Map'
import Resources from './components/Resources'
import ReferralSourceModal from './components/ReferralSourceModal'
import PasswordCheck from './components/PasswordCheck'
// constants
import { REFERRAL_CLOSED, REQUIRED_CHECK_STRING } from '../../../constants/mwm'

const MWMComponent = () => {
  const [shouldShowReferralModal, setShouldShowReferralModal] =
    React.useState(false)

  const [isPasswordMatched, setIsPasswordMatched] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)

  const checkPasswordRequired = () => {
    try {
      setIsLoading(true)
      const isPasswordMatchedData = localStorage.getItem('isPasswordMatched')

      const isPasswordMatched = isPasswordMatchedData === REQUIRED_CHECK_STRING

      setIsPasswordMatched(isPasswordMatched)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const onCloseModal = () => {
    setShouldShowReferralModal(false)
  }

  React.useEffect(() => {
    checkPasswordRequired()
  }, [])

  React.useEffect(() => {
    // show referrer modal if not submitted/closed before
    if (localStorage?.getItem('referrer') !== REFERRAL_CLOSED) {
      setTimeout(() => {
        setShouldShowReferralModal(true)
      }, 3000)
    }
  }, [])

  return (
    !isLoading && (
      <div className={'mwm-container'}>
        {isPasswordMatched ? (
          <>
            <Header />
            <Map />
            <Resources />
          </>
        ) : (
          <PasswordCheck checkPassword={checkPasswordRequired} />
        )}
        <ReferralSourceModal
          isOpen={shouldShowReferralModal}
          onClose={onCloseModal}
        />
      </div>
    )
  )
}

export default MWMComponent
